import { TeamCommunicator } from '@/redux/types/team'
import axiosInstance from './apiClient'
import { getErrorMessage } from '@/lib/utils'
import { BulkCommunicatorAssignment } from '@/redux/types/teamChat'
import { AxiosError } from 'axios'

export const fetchTeamsByRoom = async (roomId: string) => {
  try {
    const response = await axiosInstance.get(`/oge/rooms/${roomId}/teams/`)
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}

export const createTeam = async (
  roomId: string,
  teamData: { name: string; description?: string }
) => {
  try {
    const response = await axiosInstance.post(
      `/oge/rooms/${roomId}/teams/`,
      teamData
    )
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}

export const updateTeam = async (
  teamId: number,
  teamData: { name: string; description?: string }
) => {
  try {
    const response = await axiosInstance.put(`/oge/teams/${teamId}/`, teamData)
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}

export const deleteTeam = async (teamId: number) => {
  try {
    const response = await axiosInstance.delete(`/oge/teams/${teamId}/`)
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}

export interface BulkPlayerAssignment {
  player_id: string
  team_id: number | null
}

export interface BulkAssignmentResponse {
  successful_assignments: Array<{
    player_id: string
    team_id: number | null
    message: string
  }>
  failed_assignments: Array<{
    player_id: string
    error: string
  }>
  total_processed: number
  successful_count: number
  failed_count: number
}

export const bulkAssignPlayersToTeams = async (
  roomId: string,
  assignments: BulkPlayerAssignment[]
): Promise<BulkAssignmentResponse> => {
  try {
    const response = await axiosInstance.put(
      `/oge/rooms/${roomId}/players/bulk-assign-teams/`,
      {
        assignments,
      }
    )
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}

export const getTeamCommunicators = async (
  teamId: number
): Promise<TeamCommunicator[]> => {
  try {
    const response = await axiosInstance.get(
      `/oge/teams/${teamId}/communicators/`
    )
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}

export const getTeamCommunicatorForRound = async (
  teamId: number,
  roundId: number
): Promise<TeamCommunicator | null> => {
  try {
    const response = await axiosInstance.get(
      `/oge/teams/${teamId}/communicators/${roundId}/`
    )
    return response.data
  } catch (error) {
    if (error instanceof AxiosError && error.response?.status === 404) {
      return null
    }
    throw new Error(getErrorMessage(error))
  }
}

export interface BulkCommunicatorResponse {
  successful_assignments: Array<{
    team_id: number
    game_round_id: number
    round_number: number
    communicator_id: number
    message: string
    data: TeamCommunicator
  }>
  failed_assignments: Array<{
    team_id: number
    game_round_id: number
    error: string
  }>
  total_processed: number
  successful_count: number
  failed_count: number
}

export const bulkSetTeamCommunicators = async (
  roomId: string,
  assignments: BulkCommunicatorAssignment[]
): Promise<BulkCommunicatorResponse> => {
  try {
    const response = await axiosInstance.post(
      `/oge/rooms/${roomId}/communicators/bulk/`,
      {
        assignments,
      }
    )
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}
